module.exports = __webpack_public_path__ + "img/dance.b996d26b.jpg";